/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */
import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';

AnnotationsHandler.registerHandler('@DEFERRED', (propertyRef: string, c11nEnv: C11nEnv) => {
  const value = c11nEnv.getFieldMetadata(propertyRef);
  if (!value?.isDeclarativeTarget) {
    return c11nEnv.getValue(propertyRef);
  }
  return {
    isDeferred: true,
    propertyName: propertyRef
  };
});
